import { TariffPlan } from '@app/types/TariffPlan';
import { Subscription } from '@app/hooks/query/useSubscriptionData.js';
import { SubscriptionBillingPeriod } from '@app/config';
import { AccountType } from '@app/constants/constants';

export enum ModalStep {
    SELECT = 'select',
    CONFIRM = 'confirm'
}

export interface ModalChangeSubscriptionPlanV2Props {
    plans: TariffPlan[];
    isOpen: boolean;
    closeModal: () => void;
    onPlanChange: (stripeId: string) => void;
    currentPlan: Subscription;
    isSaving?: boolean;
    accountType: AccountType;
}

export interface BillingFrequencyToggleProps {
    value: SubscriptionBillingPeriod;
    onChange: (value: SubscriptionBillingPeriod) => void;
    className?: string;
}

export interface PlanSelectionStepProps {
    billingFrequency: SubscriptionBillingPeriod;
    setBillingFrequency: (frequency: SubscriptionBillingPeriod) => void;
    plans: TariffPlan[];
    currentPlan: Subscription;
    onPlanSelect: (plan: TariffPlan) => void;
    accountType: AccountType;
}

export interface HeaderProps {
    step: ModalStep;
    getModalTitle: () => string;
    onClose: () => void;
}
